import { Button } from "antd"
import { Close, Menu } from "@mui/icons-material"
import { englishFlag, italyFlag } from "../../Assets"
import { useDispatch, useSelector } from 'react-redux'
import { Select } from 'antd'
import { setLanguage } from "../../Redux/actions/languageActions"
import { translations, version } from "../../utils/constants"

const Header = ({ setVisible, visible }) => {
    const dispatch = useDispatch()
    const language = useSelector((state) => state.language?.language)
    const handleLanguageChange = (value) => {
        dispatch(setLanguage(value))
    }

    const toggleMenu = () => {
        setVisible(!visible)
    }
    return (
        <>
            <div className="header-main-div">
                <div className="header-inner-div">
                    <div className="header-inner2-div">
                        <div className="header-heading-div">
                            <Button
                                className="menu-button"
                                type="primary"
                                icon={visible ? <Close /> : <Menu />}
                                onClick={toggleMenu}
                            />
                            <h1>{translations[language]?.ExpenseRegister}</h1>
                        </div>
                        <div className='header-icons'>
                            <div className="header-language-div">
                                <span className="version_txt">v{version}</span>
                                <Select
                                    defaultValue={language}
                                    style={{
                                        width: 30,
                                        marginRight: '11px',
                                    }}
                                    onChange={handleLanguageChange}
                                    suffixIcon={null}
                                    dropdownMatchSelectWidth={false}
                                    dropdownStyle={{
                                        minWidth: 5,
                                        padding: 0
                                    }}
                                    className="flag-select"
                                >
                                    <Option value="it">
                                        <img
                                            src={italyFlag}
                                            alt="Italian"
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </Option>
                                    <Option value="en">
                                        <img
                                            src={englishFlag}
                                            alt="English"
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </Option>
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Header